import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayerByUserId } from "../ApiProvider";
import { useCreateLeague } from "../api/LeagueApiProvider";
import { UserContext } from "../auth/UserProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { LeagueForm } from "./LeagueForm";
export const CreateLeague = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const navigate = useNavigate();
    const { user: contextUser, loading: isContextUserLoading } = useContext(UserContext);
    const { isLoading: isPlayerLoading, error: playerError } = useRetrievePlayerByUserId({ userId: contextUser?.pk });
    const onSuccess = async (data) => {
        const league = data.data;
        navigate(`/leagues/${league.id}/`);
    };
    const onError = (error) => {
        setLoading(false);
        setError(error);
    };
    const mutation = useCreateLeague({
        onMutate: () => setLoading(true),
        onSuccess,
        onError,
    });
    if (loading || isPlayerLoading || isContextUserLoading) {
        return _jsx(Loading, {});
    }
    if (playerError) {
        return _jsx(ErrorView, { error: playerError });
    }
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!error, message: "Failed to create league. Please try again.", onClose: () => setError(undefined) }), _jsx(Typography, { variant: "h4", gutterBottom: true, sx: { fontSize: { xs: "1.75rem", sm: "2.125rem" } }, children: "Create League" }), _jsx(LeagueForm, { onSubmit: mutation.mutate })] }));
};
